export default "__VITE_ASSET__DgmIer_j__"